function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#E6AC39"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.252 3.207L.946 4.513a3.236 3.236 0 000 4.572l1.306 1.306c4.276 4.277 11.216 4.277 15.497 0l1.303-1.306a3.228 3.228 0 00-.002-4.573l-1.301-1.305c-4.28-4.276-11.22-4.276-15.497 0zm14.214 1.05l.117.115 1.302 1.306c.622.62.622 1.624.002 2.241l-1.304 1.308c-3.636 3.632-9.533 3.632-13.166 0L2.11 7.92a1.588 1.588 0 010-2.241l1.306-1.306C7.01.779 12.82.74 16.467 4.257z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.998 2.395c-2.35 0-4.246 1.98-4.246 4.402 0 2.427 1.896 4.407 4.246 4.407 2.354 0 4.25-1.98 4.25-4.407 0-2.423-1.896-4.402-4.25-4.402zm0 1.398c1.568 0 2.852 1.34 2.852 3.004 0 1.668-1.284 3.009-2.852 3.009-1.564 0-2.848-1.341-2.848-3.009 0-1.663 1.284-3.004 2.848-3.004z"
}));

function SvgInteriorToggleHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14"
  }, props), _ref);
}

export default SvgInteriorToggleHover;